export const SET_SELECTED_LIVE_CAMERA_BY_VID = 'V3_SET_SELECTED_LIVE_CAMERA_BY_VID'
export const UNSET_SELECTED_LIVE_CAMERA_BY_VID = 'V3_UNSET_SELECTED_LIVE_CAMERA_BY_VID'
export const GET_USER_INFO_CMS = 'V3_GET_USER_INFO_CMS'